goog.provide("shadow.js.shim.module$src$svg$person$person_3_svg$default");
shadow.js.shim.module$src$svg$person$person_3_svg$default = shadow.js.shim.module$src$svg$person$person_3_svg.default;
